module.exports = __webpack_public_path__ + "img/whatsapp-light.8aba8989.svg";